var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F1111",
    fillRule: "evenodd",
    d: "M2.136 2.134a.9.9 0 0 0 0 1.272l8.592 8.592-8.592 8.591a.9.9 0 1 0 1.273 1.273l8.592-8.591 8.59 8.59a.9.9 0 1 0 1.274-1.272l-8.592-8.591 8.592-8.592a.9.9 0 1 0-1.273-1.272L12 10.724l-8.592-8.59a.9.9 0 0 0-1.273 0",
    clipRule: "evenodd"
  })));
};
export default SvgClose;